/**
 * Fetches a color value from the theme's colors, automatically assuming the path
 * starts with 'colors.' and ends with '.base.hex'. This simplifies the usage when
 * you're accessing color values that follow this consistent structure in the theme.
 *
 * @param {Object} theme
 * @param {String} colorKey - The middle part of the path in the theme, omitting 'colors.' and '.base.hex'.
 * @param {String} [fallback='inherit'] - Optional fallback color if the path doesn't resolve.
 * @returns {String} - The resolved color value or the fallback.
 */

var getColor = function getColor(theme, colorKey) {
  var shade = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'base';
  var fallback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'inherit';
  var fullPath = "colors.".concat(colorKey, ".").concat(shade, ".hex");
  return fullPath.split('.').reduce(function (acc, part) {
    return acc === null || acc === void 0 ? void 0 : acc[part];
  }, theme) || fallback;
};
var getColor$1 = getColor;

export { getColor$1 as default };
//# sourceMappingURL=getColor.js.map
